<script setup lang="ts">
import Tag from 'primevue/tag';

type AccountLabel = {
  value: string;
  color: string;
};

const props = defineProps<{
  label?: AccountLabel | null;
}>();
</script>

<template>
  <Tag
    v-if="props.label?.value"
    icon="pi pi-tag"
    :value="props.label.value"
    class="!rounded-none !text-sm !leading-none !py-1 !px-2 !font-semibold"
    :style="{ background: '#FFFFFF', color: props.label.color }"
  />
</template>
